'use strict';

const CartFormClass = require('./CartForm.js');

const CartForm = {
  init({ cart }, done) {
    const cartForm = new CartFormClass(cart); // eslint-disable-line no-unused-vars
    return done();
  },
};

module.exports = CartForm;
